const muster = require('@dbk-legacy/muster');
const { redirectOn } = require('@dbk-legacy/muster/helpers');
const { ref } = require('@dbk-legacy/muster/utils');
const app = require('./create-app');
const stubbedHandler = require('./resources/request-handler/stubbed');



function client(defaultEnv) {
  return (musterApp, falcorModel, defaultHandlers) => {
    musterApp
      .require('rosterEbanking.env', { get: true })
      .import('remote.ebanking', muster().match('*', defaultHandlers))
      .match('ebanking.*', redirectOn(
        ref('rosterEbanking.env'),
        env => `${env === 'static' ? 'local' : 'remote'}.ebanking`
      ));

    if (defaultEnv === 'static') {
      musterApp.import('local.ebanking', app({ requestHandler: stubbedHandler }));
    }

    return musterApp;
  }
}

module.exports = client;
